import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class Interceptor implements HttpInterceptor {
    constructor() {

    }
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = sessionStorage.getItem('token');
        let customReq = request;
        
        if (token) {
            customReq = request.clone({ 
                headers: request.headers.append('Authorization', `Bearer ${token}`)
            });
        }
        
        return next.handle(customReq);
    }
}
